import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Observable } from 'rxjs';
import { SERVICE_ENDPOINTS } from '../../core/configs/service-endpoints';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { PaymentPageLinkCreate } from '../dtos/payment-page/payment-page-link-create';
import { PaymentPageLinkUpdate } from '../dtos/payment-page/payment-page-link-update';

@Injectable({
  providedIn: 'root'
})
export class PaymentPageLinkService extends BaseCrudService<PaymentPageLinkCreate, PaymentPageLinkUpdate> {

  baseUrl = this.runtimeConfig.dataBackend;

  constructor() {
    super();
  }

  /**
   * Get payment and donation links, with LazyLoading-Params (paging), for a specific payment page
   * @param lazyLoadEvent
   * @param pageId
   */
  findPage(lazyLoadEvent: LazyLoadEvent, pageId: string): Observable<ServiceResult> {
    let params = new HttpParams().set('search', JSON.stringify(lazyLoadEvent));
    params = params.append('pageId', pageId);
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + SERVICE_ENDPOINTS.GET_PAYMENT_PAGE_LINKS, {headers, params});
  }

}
